import { render, staticRenderFns } from "./OfferLogs.vue?vue&type=template&id=13d16c68&"
import script from "./OfferLogs.vue?vue&type=script&lang=js&"
export * from "./OfferLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports